import React from 'react';
import {useState} from 'react'

import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';


const Programare = (props) => {
  const [isLoading, setIsLoading] = useState(true);

    return (
      <div>
        {isLoading && <LoadingSpinner asOverlay/>}
        <div style={{ height: "700px"}}>
            <iframe
                src="https://calendly.com/varaimpreuna/vara-impreuna-2024-clone"
                width="100%"
                height="100%"
                frameborder="0"
                onLoad={()=>setIsLoading(false)}
            ></iframe>
        </div>
        {!isLoading && props.children}
      </div>
    );
}

export default Programare;
